import { render, staticRenderFns } from "./OrdersNew.vue?vue&type=template&id=5b8bdf8a&"
import script from "./OrdersNew.vue?vue&type=script&lang=js&"
export * from "./OrdersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports